import { useEffect, useState } from "react";
import { StaffuseAuth } from "../../../../security/StaffuseAuth";
import { Get_Count_Of_ArrivalDeparture_Status } from "../../api/Get_Count_Of_ArrivalDeparture_Status";

function Tally() {
  const { logout } = StaffuseAuth();

  const [getIncompleteArrivalDeparture, setgetIncompleteArrivalDeparture] =
    useState([]);
  const [getIn_ProgressArrivalDeparture, setgetIn_ProgressArrivalDeparture] =
    useState([]);
  const [
    getAwaiting_ReviewArrivalDeparture,
    setgetAwaiting_ReviewArrivalDeparture,
  ] = useState([]);
  const [getCompleteArrivalDeparture, setgetCompleteArrivalDeparture] =
    useState([]);

  useEffect(() => {
    Get_Count_Of_ArrivalDeparture_Status(
      setgetCompleteArrivalDeparture,
      "Complete",
      logout
    );
    Get_Count_Of_ArrivalDeparture_Status(
      setgetAwaiting_ReviewArrivalDeparture,
      "Awaiting_Review",
      logout
    );
    Get_Count_Of_ArrivalDeparture_Status(
      setgetIn_ProgressArrivalDeparture,
      "In_Progress",
      logout
    );
    Get_Count_Of_ArrivalDeparture_Status(
      setgetIncompleteArrivalDeparture,
      "Incomplete",
      logout
    );
  }, []);

  const arr_allDates = ["7th July", "28th July", "18th Aug"];

  //Get teh Count from the Object with a Specific Date
  function getCountFromDate(date, Arr) {
    let result = Arr.filter((obj) => obj._id === date);
    if (result.length === 0) {
      return 0;
    } else {
      return result[0].Count || 0;
    }
  }

  //Sum all the "Count" or every object in an array
  function sumAllCountsInArray(Arr) {
    return Arr.reduce((accumulator, current) => {
      return accumulator + (current.Count || 0);
    }, 0);
  }

  return (
    <div style={{ marginLeft: "10px", display: "flex" }}>
      <div style={{ marginRight: "10px" }}>
        <h1>Progress</h1>
        <h4>
          Incomplete: {sumAllCountsInArray(getIncompleteArrivalDeparture)}
          <br></br>
          In Progress: {sumAllCountsInArray(getIn_ProgressArrivalDeparture)}
          <br></br>
          Awaiting Review:{" "}
          {sumAllCountsInArray(getAwaiting_ReviewArrivalDeparture)}
          <br></br>
          Complete: {sumAllCountsInArray(getCompleteArrivalDeparture)}
        </h4>
      </div>
      {arr_allDates.map((chosenDate) => (
        <div style={{ marginRight: "10px" }}>
          <h1>{chosenDate}</h1>
          <h4>
            Incomplete:{" "}
            {getCountFromDate(chosenDate, getIncompleteArrivalDeparture)}
            <br></br>
            In Progress:{" "}
            {getCountFromDate(chosenDate, getIn_ProgressArrivalDeparture)}
            <br></br>
            Awaiting Review:{" "}
            {getCountFromDate(chosenDate, getAwaiting_ReviewArrivalDeparture)}
            <br></br>
            Complete:{" "}
            {getCountFromDate(chosenDate, getCompleteArrivalDeparture)}
          </h4>
        </div>
      ))}
    </div>
  );
}

export default Tally;
